export default __webpack_public_path__ + "static/N0182-7ee461db2cbeb34786566adb50095e06.png";